module.exports = __webpack_public_path__ + "img/Privacy_Desktop.jpg";